import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';






const JavaScriptLesson31 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3>Syntax</h3>
  <pre><code>if (condition1) {"Statements to be executed ...<br/>"}else if (condition2) {"Statements to be executed ...<br/>"}else {"Statements to be executed ..."}</code></pre>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson31